import MathUtils from '../../util/MathUtils.js';
import {nicelyRounded} from '../../util/CommonUtils.js';
import LineFunctionResult from './LineFunctionResult.js';

export default class LineFunctionMean {
  constructor(labelPattern) {
    this._labelPattern = labelPattern;
  }

  calculateLine(x, y, xAxis) {
    const mean = MathUtils.mean(y);
    return [new LineFunctionResult([[xAxis[0], mean], [xAxis[1], mean]], this._labelPattern.replace('${value}', nicelyRounded(mean)))];
  }
}